(function () {
	function initPostalFields(root) {
		root.querySelectorAll('[data-recupera-postal]').forEach(function (input) {
			if (input.dataset.recuperaReady === 'true') return;
			input.dataset.recuperaReady = 'true';
			var wrapper = input.closest('.recupera-purchase__postal');
			var button = wrapper && wrapper.querySelector('[data-recupera-calculate]');
			var message = wrapper && wrapper.querySelector('[data-recupera-shipping-message]');
			var results = wrapper && wrapper.querySelector('[data-recupera-shipping-results]');
			var variantId = wrapper && wrapper.dataset.variantId;
			if (!button) return;

			input.addEventListener('input', function () {
				var digits = input.value.replace(/\D/g, '').slice(0, 8);
				input.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
				button.disabled = digits.length !== 8;
				if (message) message.hidden = true;
				if (results) results.hidden = true;
			});

			button.addEventListener('click', function () {
				var estimator = window.SterilairShippingEstimate;
				if (!estimator || !variantId) { if (message) message.hidden = false; return; }

				if (message) message.hidden = true;
				if (results) { results.hidden = false; results.textContent = 'Calculando…'; }
				button.disabled = true;

				estimator.estimateShipping(variantId, input.value)
					.then(function (data) {
						var rates = data && data.shipping_rates;
						if (!results) return;
						if (!rates || !rates.length) {
							results.innerHTML = '<p class="recupera-purchase__shipping-error">Não encontramos opções de frete para esse CEP.</p>';
							return;
						}
						results.innerHTML = rates.map(function (rate) {
							return '<div class="recupera-purchase__shipping-rate"><span>' + rate.name + '</span><strong>' + estimator.formatShippingPrice(rate.price) + '</strong></div>';
						}).join('');
					})
					.catch(function () {
						if (results) results.hidden = true;
						if (message) message.hidden = false;
					})
					.finally(function () { button.disabled = false; });
			});
		});
	}

	function formatNumber(value) {
		return new Intl.NumberFormat('pt-BR').format(value);
	}

	function hydrateReviews(root, summary) {
		var rating = Number(summary.aggregateRating || 0);
		var recommended = Math.round(Number(summary.recommendedPercentage || 0));
		var progress = Math.max(0, Math.min(100, recommended));
		var ratingText = rating.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

		root.querySelectorAll('[data-recupera-rating]').forEach(function (item) { item.textContent = ratingText; });
		root.querySelectorAll('[data-recupera-count]').forEach(function (item) { item.textContent = formatNumber(Number(summary.reviewCount || 0)); });
		root.querySelectorAll('[data-recupera-recommended]').forEach(function (item) { item.textContent = recommended + '%'; });
		root.querySelectorAll('[data-recupera-progress-rating]').forEach(function (item) { item.textContent = ratingText + '/5'; });
		requestAnimationFrame(function () {
			root.querySelectorAll('[data-recupera-progress]').forEach(function (bar) { bar.style.width = progress + '%'; });
		});
	}

	function initReviews(root) {
		root.querySelectorAll('[data-recupera-reviews]').forEach(function (reviews) {
			if (reviews.dataset.recuperaReady === 'true') return;
			reviews.dataset.recuperaReady = 'true';
			var url = reviews.dataset.apiUrl;
			if (!url) return;
			if (!window.__sterilairKonfidencySummaryPromise) {
				window.__sterilairKonfidencySummaryPromise = fetch(url)
					.then(function (response) {
						if (!response.ok) throw new Error('Konfidency request failed');
						return response.json();
					})
					.then(function (data) { return data.reviews.summary; });
			}
			window.__sterilairKonfidencySummaryPromise
				.then(function (summary) { hydrateReviews(reviews.closest('[data-recupera-section]') || reviews, summary); })
				.catch(function () { reviews.setAttribute('data-recupera-error', 'true'); });
		});
	}

	function init(root) {
		initPostalFields(root);
		initReviews(root);
	}

	document.addEventListener('DOMContentLoaded', function () { init(document); });
	document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
